import React, { useEffect,useState } from "react";
import { Link } from "react-scroll";
import "./Header.scss";
import useSectionObserver from "../../components/useSectionObserver";

const Header = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState("home");

  useSectionObserver(setActiveSection);

  const handleClick = () => {
    setShowMenu(false);
  };

    useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav className={`header-container${scrolled ? " scrolled" : ""}`}>
      <div className="header-content">
        <p className="logo">Khanh Bui</p>

        <div className="menu-icon" onClick={() => setShowMenu(!showMenu)}>
          <span>&#9776;</span>
        </div>

        <div className={`nav-links-container ${showMenu ? "show" : ""}`}>
          <ul className="nav-links">
            {["home", "about", "projects", "contact"].map((id) => (
              <li key={id}>
                <Link
                  to={id}
                  smooth={true}
                  duration={500}
                  offset={-60} // Click → scroll tới đúng đầu section
                  className={activeSection === id ? "active" : ""}
                  onClick={handleClick}
                >
                  {id.charAt(0).toUpperCase() + id.slice(1)}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
